// extracted by mini-css-extract-plugin
export default {"confirm":"Confirm-module__confirm--rF0fe","copilotRun":"Confirm-module__copilotRun--hSoCd"};